export const sanitize = (obj: any[]) => {
  return JSON.parse(
    JSON.stringify(obj, (key, value) => {
      return value === null ? undefined : value;
    }),
  );
};

export const fullWidth = { md: 24, lg: 24, xl: 24, xxl: 24 };
